import { Stack } from '@healthinal/ui';
import { createFileRoute } from '@tanstack/react-router';
import { ContactAttemptsList } from './components/contact-attempt/ContactAttemptsList.tsx';
import { TracingContactContactCard } from './components/contact/TracingContactContactCard.tsx';
import { TracingContactDetailsCard } from './components/details/TracingContactDetailsCard.tsx';
import { LabOrderResultList } from './components/lab-order/LabOrderResultList.tsx';
import { TbiTherapyForm } from './components/preventive-therapy/TbiTherapyForm.tsx';
import { TuberculosisHistoryCard } from './components/TuberculosisHistoryCard.tsx';

export const Route = createFileRoute('/contact-tracing/$patientId/')({
  component: ContactTracingPatientDetails,
});

function ContactTracingPatientDetails() {
  const { patientId } = Route.useParams();

  return (
    <Stack direction="row" gap={2}>
      <Stack flex={1} gap={2}>
        <TracingContactDetailsCard tracingContactId={patientId} />
        <TuberculosisHistoryCard tracingContactId={patientId} />
      </Stack>
      <Stack flex={1} gap={2}>
        <TracingContactContactCard tracingContactId={patientId} />
        <ContactAttemptsList patientId={patientId} />
        <LabOrderResultList patientId={patientId} />
        <TbiTherapyForm patientId={patientId} />
      </Stack>
    </Stack>
  );
}
